import React from 'react'
import styles from './SaveFailureDialog.scss'
import { StyledModal } from 'common/StyledModal'
import { Button } from 'common/Button'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const SaveFailureDialog = ({ onRequestClose }) => (
  <StyledModal maxWidth={400} onRequestClose={onRequestClose} showModal>
    <div className={styles.SaveFailureDialog}>
      <h2><T id='SaveFailureDialog.trouble' defaultMessage="We're having trouble saving your report." /></h2>
      <p><T id='SaveFailureDialog.servers' defaultMessage="Don't worry - all your changes up to the last minute or so are safe and sound on our servers." /></p>
      <p><T id='SaveFailureDialog.checkInternet' defaultMessage='Please check that your computer is connected to the Internet, and reload the page.' /></p>
      <p>
        <T
          id='SaveFailureDialog.help'
          defaultMessage='If you continue to see this message, please <a>contact support</a>.'
          values={{ a: (...chunks) => <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>{chunks}</a> }} />
      </p>
      <div className={styles.buttons}>
        <a onClick={window.location.reload}><Button className={styles.reloadButton}><T id='SaveFailureDialog.reload' defaultMessage='Reload' /></Button></a>
        <Button className={styles.closeButton} type='default' onClick={onRequestClose}><Msg m={commonCTAs.close} /></Button>
      </div>
    </div>
  </StyledModal>
)
